import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import "./SectionWebDesignNew.css";
import "../../../GalleryShared.css";


// New 
import DDEULTRA   from "../../../../../Assets/Images/gallary/webdesign/DDEWeb.webp";
import Floret  from "../../../../../Assets/Images/gallary/webdesign/Floret Mockup.webp";
import omkara   from "../../../../../Assets/Images/gallary/webdesign/omkara spaces mockup.png";
import Balaji   from "../../../../../Assets/Images/gallary/webdesign/Balaji 2.webp";
import energizing   from "../../../../../Assets/Images/gallary/webdesign/energizing.png";
import Vasuki   from "../../../../../Assets/Images/gallary/webdesign/Vasuki cement website mockup.webp";
import powertron   from "../../../../../Assets/Images/gallary/webdesign/powertron.png";
import yobykes   from "../../../../../Assets/Images/gallary/webdesign/Yoi 1.png";
import adortraffic   from "../../../../../Assets/Images/gallary/webdesign/02.jpg";
import OmkaraHostel   from "../../../../../Assets/Images/gallary/webdesign/Omkara Hostel.webp";
import Hykin   from "../../../../../Assets/Images/gallary/webdesign/Hykin 2.webp";
import RNS   from "../../../../../Assets/Images/gallary/webdesign/RNS.webp";
const ALL_SLIDES_WD = [
  { url: "https://ddeultra.com/",  left: [DDEULTRA],                        behind: [],              thumb: DDEULTRA,   industry: "Manufacturing", sub: "" },
   { url: "https://floretindia.com/",  left: [Floret],                        behind: [],              thumb: Floret,   industry: "Horticulture", sub: "" },
    { url: "https://omkaraspaces.com/",  left: [omkara],                        behind: [],              thumb: omkara,   industry: "Real Estate", sub: "" },
     { url: "https://balajiblossoms.com/",  left: [Balaji],                        behind: [],              thumb: Balaji,   industry: "Horticulture", sub: "" },
  { url: "https://energizingindia.tv/",  left: [energizing],                        behind: [],              thumb: energizing,   industry: "Manufacturing", sub: "" },
  { url: "https://vasukiinfra.com/",    left: [Vasuki],                    behind: [],            thumb: Vasuki, industry: "Manufacturing",  sub: ""   },
  { url: "https://adorpowertron.com/",    left: [powertron],       behind: [], thumb: powertron, industry: "Manufacturing", sub: "" },
  { url: "https://yobykes.com/",    left: [yobykes],       behind: [], thumb: yobykes, industry: "Manufacturing", sub: "" },
    { url: "https://adortraffic.com/",    left: [adortraffic],       behind: [], thumb: adortraffic, industry: "Manufacturing", sub: "" },
    { url: "https://omkarahostel.com/",    left: [OmkaraHostel],       behind: [], thumb: OmkaraHostel, industry: "Real Estate", sub: "" },
    { url: "https://haykinsystems.com/",    left: [Hykin],       behind: [], thumb: Hykin, industry: "Manufacturing", sub: "" },
    { url: "https://rnsnursery.in/",    left: [RNS],       behind: [], thumb: RNS, industry: "Horticulture", sub: "" },
];

const INDUSTRIES_WD = ["Manufacturing", "Horticulture", "Real Estate"];

/* ── Helpers ── */
const WD_IMAGE_EXTS = [".png", ".jpg", ".jpeg", ".webp", ".gif", ".avif", ".svg"];

function isImageSrcWD(src) {
  if (!src) return false;
  return WD_IMAGE_EXTS.some((ext) => src.toLowerCase().endsWith(ext));
}

/* ══════════════════════════════════════════════
   VIDEO / IMAGE PLAYER  (prefix: wd-)
══════════════════════════════════════════════ */
function VideoPlayerWD({ src, thumb, videoRef: externalRef }) {
  const internalRef = useRef(null);
  const videoRef    = externalRef ?? internalRef;
  const progressRef = useRef(null);
  const wrapRef     = useRef(null);
  const hideTimer   = useRef(null);

  const [playing,   setPlaying]   = useState(false);
  const [progress,  setProgress]  = useState(0);
  const [duration,  setDuration]  = useState(0);
  const [showCtrl,  setShowCtrl]  = useState(false);
  const [isFS,      setIsFS]      = useState(false);
  const [showThumb, setShowThumb] = useState(true);
  const [muted,     setMuted]     = useState(true);
  const [volume,    setVolume]    = useState(1);

  const isImage = isImageSrcWD(src);

  useEffect(() => {
    setShowThumb(true);
    setPlaying(false);
    setProgress(0);
    setDuration(0);
  }, [src]);

  useEffect(() => () => clearTimeout(hideTimer.current), []);

  useEffect(() => {
    const onChange = () => setIsFS(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", onChange);
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, []);

  const fmt = (s) => {
    if (!s || isNaN(s)) return "0:00";
    return `${Math.floor(s / 60)}:${Math.floor(s % 60).toString().padStart(2, "0")}`;
  };

  const togglePlay = (e) => {
    e.stopPropagation();
    if (isImage) return;
    const v = videoRef.current; if (!v) return;
    v.paused ? v.play().catch(() => {}) : v.pause();
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    setMuted((prev) => {
      if (videoRef.current) videoRef.current.muted = !prev;
      return !prev;
    });
  };

  const handleVolume = (e) => {
    e.stopPropagation();
    const val = parseFloat(e.target.value);
    setVolume(val);
    if (videoRef.current) {
      videoRef.current.volume = val;
      videoRef.current.muted  = val === 0;
    }
    setMuted(val === 0);
  };

  const toggleFS = (e) => {
    e.stopPropagation();
    if (!document.fullscreenElement) wrapRef.current?.requestFullscreen().catch(() => {});
    else document.exitFullscreen();
  };

  const handleSeek = (e) => {
    e.stopPropagation();
    if (isImage) return;
    const bar = progressRef.current; const v = videoRef.current;
    if (!bar || !v) return;
    const rect = bar.getBoundingClientRect();
    v.currentTime = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width)) * v.duration;
  };

  const showControls = () => {
    setShowCtrl(true);
    clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setShowCtrl(false), 2500);
  };

  const effectiveVolume = muted ? 0 : volume;

  const VolumeIcon = () => {
    if (muted || effectiveVolume === 0) return (
      <svg viewBox="0 0 24 24" fill="white" width="20" height="20">
        <path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06A8.99 8.99 0 0 0 17.73 18l2 2L21 18.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
      </svg>
    );
    if (effectiveVolume < 0.5) return (
      <svg viewBox="0 0 24 24" fill="white" width="20" height="20">
        <path d="M18.5 12A4.5 4.5 0 0 0 16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"/>
      </svg>
    );
    return (
      <svg viewBox="0 0 24 24" fill="white" width="20" height="20">
        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
      </svg>
    );
  };

  /* Image mode */
  if (isImage) {
    return (
      <div ref={wrapRef} className="wd-cvid">
        <img src={src} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", background: "#000" }} />
      </div>
    );
  }

  /* Video mode */
  return (
    <div
      ref={wrapRef}
      className="wd-cvid"
      onMouseMove={showControls}
      onMouseEnter={showControls}
      onMouseLeave={() => { clearTimeout(hideTimer.current); setShowCtrl(false); }}
      onClick={togglePlay}
    >
      <video
        ref={videoRef}
        src={src}
        muted={muted}
        playsInline
        loop={false}
        onTimeUpdate={() => { const v = videoRef.current; if (v?.duration) setProgress(v.currentTime / v.duration); }}
        onLoadedMetadata={() => { if (videoRef.current) setDuration(videoRef.current.duration); }}
        onPlay={() => { setPlaying(true); setShowThumb(false); }}
        onPause={() => setPlaying(false)}
        onEnded={() => { setPlaying(false); setProgress(0); }}
        style={{ width: "100%", height: "100%", objectFit: isFS ? "contain" : "fill", display: "block", background: "#000" }}
      />

      {thumb && (
        <div className={`wd-cvid-thumb-overlay${showThumb ? " wd-cvid-thumb-overlay--visible" : ""}`}>
          <img src={thumb} alt="" />
        </div>
      )}

      {!playing && (
        <div className="wd-cvid-play-overlay" onClick={togglePlay}>
          <svg viewBox="0 0 80 80" fill="none" width="52" height="52">
            <circle cx="40" cy="40" r="40" fill="rgba(0,0,0,0.45)" />
            <polygon points="32,24 60,40 32,56" fill="white" />
          </svg>
        </div>
      )}

      <div className={`wd-cvid-ctrl${showCtrl ? " wd-cvid-ctrl--show" : ""}`}>

        {/* Play / Pause */}
        <button className="wd-cvid-playbtn" onClick={togglePlay}>
          {playing
            ? <svg viewBox="0 0 24 24" fill="white" width="22" height="22"><rect x="5" y="3" width="4" height="18" rx="1"/><rect x="15" y="3" width="4" height="18" rx="1"/></svg>
            : <svg viewBox="0 0 24 24" fill="white" width="22" height="22"><polygon points="5,3 19,12 5,21"/></svg>
          }
        </button>

        {/* Timestamp */}
        <span className="wd-cvid-time">{fmt(progress * duration)}</span>

        {/* Seek bar */}
        <div ref={progressRef} className="wd-cvid-bar" onClick={handleSeek}>
          <div className="wd-cvid-bar-fill" style={{ width: `${progress * 100}%` }} />
          <div className="wd-cvid-bar-thumb" style={{ left: `${progress * 100}%` }} />
        </div>

        {/* Duration */}
        <span className="wd-cvid-time">{fmt(duration)}</span>

        {/* Volume group */}
        <div className="wd-cvid-vol-group" onClick={(e) => e.stopPropagation()}>
          <button className="wd-cvid-playbtn" onClick={toggleMute} aria-label={muted ? "Unmute" : "Mute"}>
            <VolumeIcon />
          </button>
          <input
            className="wd-cvid-vol-slider"
            style={{ "--vol": effectiveVolume }}
            type="range"
            min="0" max="1" step="0.02"
            value={effectiveVolume}
            onChange={handleVolume}
            aria-label="Volume"
          />
        </div>

        {/* Fullscreen */}
        <button className="wd-cvid-playbtn" onClick={toggleFS}>
          {isFS
            ? <svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/></svg>
            : <svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>
          }
        </button>

      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════
   INNER SLIDER — arrow nav within a panel's array
══════════════════════════════════════════════ */
function InnerSliderWD({ srcs, thumb, videoRef }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => { setIdx(0); }, [srcs]);

  const count = srcs.length;
  const prev  = (e) => { e.stopPropagation(); setIdx((i) => (i - 1 + count) % count); };
  const next  = (e) => { e.stopPropagation(); setIdx((i) => (i + 1) % count); };

  if (count === 0) return null;

  return (
    <div className="wd-inner-slider">
      {srcs.map((src, i) => (
        <div key={i} className={`wd-inner-layer${i === idx ? " wd-inner-layer--active" : ""}`}>
          <VideoPlayerWD
            src={src}
            thumb={i === 0 && !isImageSrcWD(src) ? thumb : undefined}
            videoRef={i === idx ? videoRef : undefined}
          />
        </div>
      ))}

      {count > 1 && (
        <>
          <button className="wd-inner-arrow wd-inner-arrow--prev" onClick={prev} aria-label="Previous">
            <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
              <polyline points="15,6 9,12 15,18" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button className="wd-inner-arrow wd-inner-arrow--next" onClick={next} aria-label="Next">
            <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
              <polyline points="9,6 15,12 9,18" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <div className="wd-inner-dots">
            {srcs.map((_, i) => (
              <button
                key={i}
                className={`wd-inner-dot${i === idx ? " wd-inner-dot--active" : ""}`}
                onClick={(e) => { e.stopPropagation(); setIdx(i); }}
                aria-label={`Item ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

/* ══════════════════════════════════════════════
   VIDEO SLIDER WEB DESIGN
══════════════════════════════════════════════ */
function VideoSliderWD({ slides }) {
  const [activeSlide, setActiveSlide] = useState(0);
  const [panelIdx,    setPanelIdx]    = useState(0);

  const mainRefs   = useRef([]);
  const behindRefs = useRef([]);
  if (mainRefs.current.length !== slides.length) {
    mainRefs.current   = slides.map((_, i) => mainRefs.current[i]   ?? React.createRef());
    behindRefs.current = slides.map((_, i) => behindRefs.current[i] ?? React.createRef());
  }

  const pauseAll = useCallback((exceptIdx) => {
    slides.forEach((_, i) => {
      if (i === exceptIdx) return;
      [mainRefs.current[i], behindRefs.current[i]].forEach((r) => {
        if (r?.current?.pause) { r.current.pause(); r.current.currentTime = 0; }
      });
    });
  }, [slides]);

  const handleThumbClick = (i) => {
    if (i === activeSlide) return;
    [mainRefs.current[activeSlide], behindRefs.current[activeSlide]].forEach((r) => {
      if (r?.current?.pause) { r.current.pause(); r.current.currentTime = 0; }
    });
    setActiveSlide(i);
    setPanelIdx(0);
    pauseAll(i);
  };

  const currentSlide = slides[activeSlide];
  const leftSrcs   = Array.isArray(currentSlide?.left)   ? currentSlide.left   : (currentSlide?.left   ? [currentSlide.left]   : []);
  const behindSrcs = Array.isArray(currentSlide?.behind) ? currentSlide.behind : (currentSlide?.behind ? [currentSlide.behind] : []);
  const hasBehind  = behindSrcs.length > 0;

  /* ── Open slide URL in new tab (skip if click was on a control) ── */
  const handleLeftClick = (e) => {
    if (!currentSlide?.url) return;
    if (e.target.closest("button, input")) return;
    window.open(currentSlide.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="wd-vslider-wrap">
      <div className="wd-vslider">

        {/* ── Left panel (clickable) ── */}
        <div
          className="wd-vslider-left-wrap"
          onClick={handleLeftClick}
          style={{ cursor: currentSlide?.url ? "pointer" : "default" }}
        >
          <div className="wd-vslider-left">

            {/* Per-slide label — overlay pill, top-left of the panel */}
            {currentSlide?.sub && (
              <div className="wd-sub-pill">{currentSlide.sub}</div>
            )}

            <div className={`wd-vslider-vid-layer${panelIdx === 0 ? " wd-vslider-vid-layer--active" : ""}`}>
              <InnerSliderWD srcs={leftSrcs} thumb={currentSlide?.thumb} videoRef={mainRefs.current[activeSlide]} />
            </div>

            {hasBehind && (
              <div className={`wd-vslider-vid-layer${panelIdx === 1 ? " wd-vslider-vid-layer--active" : ""}`}>
                <InnerSliderWD srcs={behindSrcs} thumb={currentSlide?.thumb} videoRef={behindRefs.current[activeSlide]} />
              </div>
            )}

          </div>

          {hasBehind && (
            <div className="wd-vslider-dots">
              <button className={`wd-vslider-dot${panelIdx === 0 ? " wd-vslider-dot--active" : ""}`} onClick={(e) => { e.stopPropagation(); setPanelIdx(0); }} aria-label="Main view" />
              <button className={`wd-vslider-dot${panelIdx === 1 ? " wd-vslider-dot--active" : ""}`} onClick={(e) => { e.stopPropagation(); setPanelIdx(1); }} aria-label="Alternate view" />
            </div>
          )}

          {/* ── "Visit site" badge shown on hover ── */}
          {currentSlide?.url && (
            <div className="wd-visit-badge">
              <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="15 3 21 3 21 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="10" y1="14" x2="21" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Visit Site
            </div>
          )}
        </div>

        {/* ── Thumbnail stack ── */}
        <div className="wd-thumb-stack">
          {slides.map((slide, i) => (
            <button
              key={i}
              className={`wd-thumb-stack-item${activeSlide === i ? " wd-thumb-stack-item--active" : ""}`}
              onClick={() => handleThumbClick(i)}
            >
              <img src={slide.thumb} alt={slide.sub} />
            </button>
          ))}
        </div>

      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════
   SECTION WEB DESIGN NEW
══════════════════════════════════════════════ */
export default function SectionWebDesignNew() {
  const [activeFilter, setActiveFilter] = useState(null);

  const visibleSlides = useMemo(() => {
    if (!activeFilter) return ALL_SLIDES_WD;
    return ALL_SLIDES_WD.filter((s) => s.industry === activeFilter);
  }, [activeFilter]);

  const handleFilter = (industry) => {
    setActiveFilter((prev) => (prev === industry ? null : industry));
  };

  return (
    <section className="g-section g-section--white wd-section-decor">
      <div className="g-container">

        <div className="wd-hdr">
          <div className="wd-hdr-left">
            <h2 className="wd-title">Web Design</h2>
            <p className="wd-desc">
              Translating business capabilities into structured digital
              experiences that support visibility, credibility, and engagement.
            </p>
          </div>

          <div className="wd-filter-bar">
            {INDUSTRIES_WD.map((ind) => (
              <button
                key={ind}
                className={`wd-filter-btn${activeFilter === ind ? " wd-filter-btn--active" : ""}`}
                onClick={() => handleFilter(ind)}
              >
                {ind}
              </button>
            ))}
            <button
              className={`wd-filter-clear${activeFilter ? " wd-filter-clear--visible" : ""}`}
              onClick={() => setActiveFilter(null)}
              aria-label="Clear filter"
              tabIndex={activeFilter ? 0 : -1}
            >
              <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
                <line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
                <line x1="20" y1="4" x2="4"  y2="20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
        </div>

        <div className="wd-body">
          {visibleSlides.length > 0 ? (
            <VideoSliderWD
              key={activeFilter ?? "all"}
              slides={visibleSlides}
            />
          ) : (
            <div className="wd-empty">No items found for this industry.</div>
          )}
        </div>

        <p className="wd-bottom-desc">
          Built to help businesses present information clearly, strengthen
          digital presence, and improve customer interaction.
        </p>

      </div>
    </section>
  );
}